'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _reactRedux = require('react-redux');
var _reduxForm = require('redux-form');
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _ramda = require('ramda');
var _publish = require('../../../redux/modules/normalizers/publish');var _publish2 = _interopRequireDefault(_publish);
var _OMButtonWithPreloader = require('../../OMComponents/OMButtonWithPreloader/OMButtonWithPreloader');var _OMButtonWithPreloader2 = _interopRequireDefault(_OMButtonWithPreloader);
var _validate = require('./validate');var _validate2 = _interopRequireDefault(_validate);
var _Form = require('../Form/Form.scss');var styles = _interopRequireWildcard(_Form);
var _Input = require('../Input/Input');var _Input2 = _interopRequireDefault(_Input);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

UpdatePropertyActivityContactsManualForm = function (_React$Component) {_inherits(UpdatePropertyActivityContactsManualForm, _React$Component);function UpdatePropertyActivityContactsManualForm() {var _temp, _this, _ret;_classCallCheck(this, UpdatePropertyActivityContactsManualForm);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.
    handleSubmit = function (evt) {
      _this.props.handleSubmit(_this.props.onFormSubmit)(evt);
      return true;
    }, _temp), _possibleConstructorReturn(_this, _ret);}UpdatePropertyActivityContactsManualForm.prototype.

  render = function render() {var _props =
    this.props,isLoading = _props.isLoading,translate = _props.translate;
    return (
      _react2.default.createElement('form', {
          className: styles.form,
          onSubmit: this.handleSubmit,
          noValidate: 'noValidate' },

        _react2.default.createElement(_Input2.default, {
          isRequired: true,
          name: 'primary.name',
          translate: translate,
          label: translate(
          'managePage',
          'propertyToggle',
          'missingContactsModal',
          'nameLabel'),

          placeholder: translate(
          'managePage',
          'propertyToggle',
          'missingContactsModal',
          'namePlaceholder') }),


        _react2.default.createElement(_Input2.default, {
          isRequired: true,
          name: 'primary.value',
          normalize: _publish2.default.phone,
          translate: translate,
          placeholder: translate(
          'managePage',
          'propertyToggle',
          'missingContactsModal',
          'phonePlaceholder'),

          label: translate(
          'managePage',
          'propertyToggle',
          'missingContactsModal',
          'phoneLabel') }),


        _react2.default.createElement('div', { className: styles.actions },
          _react2.default.createElement(_OMButtonWithPreloader2.default, {
            type: 'submit',
            showPreloader: isLoading,
            additionalClassName: (0, _classnames2.default)(styles.btn, styles.submitBtn, styles.fullWidth),
            innerText: translate(
            'managePage',
            'propertyToggle',
            'missingContactsModal',
            'activate') }))));





  };return UpdatePropertyActivityContactsManualForm;}(_react2.default.Component);


UpdatePropertyActivityContactsManualForm.propTypes = {
  translate: _propTypes2.default.func,
  isRtl: _propTypes2.default.bool,
  handleSubmit: _propTypes2.default.func,
  unregisterFormField: _propTypes2.default.func,
  untouch: _propTypes2.default.func,
  change: _propTypes2.default.func,
  onFormSubmit: _propTypes2.default.func,
  isLoading: _propTypes2.default.bool };


var mapStateToProps = function mapStateToProps(_ref) {var userAuthentication = _ref.userAuthentication;
  var userName = (0, _get2.default)(userAuthentication, 'data.display_name') || '';
  return {
    initialValues: { primary: { name: userName } } };

};exports.default =


(0, _ramda.compose)(
(0, _reactRedux.connect)(mapStateToProps),
(0, _reduxForm.reduxForm)({
  form: 'update-property-activity-contacts-manual-form',
  validate: _validate2.default }))(

UpdatePropertyActivityContactsManualForm);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/UpdatePropertyActivityModal/ManualForm/ManualForm.js
// module id = 2925
// module chunks = 0